import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { clearAssetPreview, isInsuranceFlowPath } from "./insurance-data";

const InsurancePreviewSession = () => {
  const { pathname } = useLocation();
  const previousPath = useRef(pathname);

  useEffect(() => {
    const previous = previousPath.current;
    if (isInsuranceFlowPath(previous) && !isInsuranceFlowPath(pathname)) {
      clearAssetPreview();
    }
    previousPath.current = pathname;
  }, [pathname]);

  return null;
};

export default InsurancePreviewSession;
